export async function logout(): Promise<void> {
  await new Promise(resolve => setTimeout(resolve, 1000));
}
